var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ReactFilterBox from "@netdata/react-filter-box";
// Library doesn't handle dynamic data, even given an updated handler instance in props
// So we extend base component and update its parser manually
// to enable autosuggestions for dynamic data
var ExtendedFilterBox = /** @class */ (function (_super) {
    __extends(ExtendedFilterBox, _super);
    function ExtendedFilterBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtendedFilterBox.prototype.componentDidMount = function () {
        if (_super.prototype.componentDidMount) {
            _super.prototype.componentDidMount.call(this);
        }
        if (this.props.query) {
            var result = this.parser.parse(this.props.query);
            if (this.props.onParseOk)
                this.props.onParseOk(result);
        }
    };
    ExtendedFilterBox.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (_super.prototype.componentDidUpdate) {
            _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        }
        if (prevProps.autoCompleteHandler !== this.props.autoCompleteHandler) {
            this.parser.setAutoCompleteHandler(this.props.autoCompleteHandler);
        }
    };
    return ExtendedFilterBox;
}(ReactFilterBox));
export { ExtendedFilterBox };
